import React from 'react';
import { motion } from 'framer-motion';
import { Check, PartyPopper } from 'lucide-react';
import { valueRows } from '../data/salesContent';
import { books } from '../data/books';
import { SectionShell } from './SectionShell';
export function ValueStackSection() {
  return <SectionShell eyebrow="Stack de valor completo" title="Lo que obtienes contra lo que pagas" className="bg-noir-950" data-id="element-311" data-mp="1hd8dzq8k06zg">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-80px'
    }} transition={{
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1]
    }} className="mx-auto max-w-3xl overflow-hidden rounded-2xl border border-gold-500/20 bg-noir-800/70" data-id="element-312" data-mp="top9llsmkecn">
        <div className="flex items-center justify-between border-b border-gold-500/15 bg-noir-700/60 px-5 py-3.5 sm:px-8 sm:py-4" data-id="element-313" data-mp="yoto569z2z08">
          <span className="text-[11px] font-bold uppercase tracking-widest2 text-cream/50" data-id="element-314" data-mp="2a25v3q113xqm">
            Lo que obtienes
          </span>
          <span className="text-[11px] font-bold uppercase tracking-widest2 text-cream/50" data-id="element-315" data-mp="1nc6w88eu34ps">
            Valor
          </span>
        </div>

        <ul data-id="element-316" data-mp="1sdwcq3ktsal9">
          {valueRows.map((row, index) => <motion.li key={row.label} initial={{
          opacity: 0,
          x: -14
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.45,
          delay: index * 0.06
        }} className="flex items-center justify-between gap-4 border-b border-cream/[0.07] px-5 py-3.5 transition-colors hover:bg-noir-700/40 sm:px-8 sm:py-4" data-id="element-317" data-mp="1weyaefz3gel4" data-mpi={index}>
              <span className="flex items-center gap-2.5 text-sm text-cream/78 sm:gap-3 sm:text-[15px]" data-id="element-318" data-mp="1idvoc383n4a7">
                <span aria-hidden="true" className="text-base" data-id="element-319" data-mp="kyrim3l43t0s">
                  {books[index].glyph}
                </span>
                {row.label}
              </span>
              <span className="shrink-0 text-sm tabular-nums text-cream/55" data-id="element-320" data-mp="pvi1szs7r4qf">
                {row.value}
              </span>
            </motion.li>)}
        </ul>

        <div className="flex items-center justify-between gap-4 border-b border-gold-500/15 bg-noir-700/50 px-5 py-4 sm:px-8 sm:py-5" data-id="element-321" data-mp="1o8vxnvplensn">
          <span className="text-xs font-bold uppercase tracking-widest2 text-gold-400" data-id="element-322" data-mp="1xz71zjd6uz02">
            Valor total real
          </span>
          <span className="font-display text-xl font-bold text-cream/70 line-through" data-id="element-323" data-mp="1a8un1ojj01zz">
            $137.00
          </span>
        </div>

        <div className="flex items-center justify-between gap-4 bg-crimson-600/12 px-5 py-5 sm:px-8 sm:py-6" data-id="element-324" data-mp="15cdw6mkxz9j7">
          <span className="flex items-center gap-2.5 text-xs font-bold uppercase tracking-widest2 text-crimson-500" data-id="element-325" data-mp="1j87xajfh4ulr">
            <Check className="h-4 w-4" aria-hidden="true" data-id="element-326" data-mp="2uphcuuvhf2hs" />
            Tú pagas hoy
          </span>
          <span className="font-display text-4xl font-bold leading-none text-cream sm:text-5xl" data-id="element-327" data-mp="2pqeka9wouoqp">
            $9.99
          </span>
        </div>
      </motion.div>

      <motion.p initial={{
      opacity: 0,
      y: 18
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5,
      delay: 0.15
    }} className="mx-auto mt-5 inline-flex items-center gap-2.5 rounded-full border border-gold-500/30 bg-gold-500/[0.08] px-4 py-2 text-[13px] font-semibold text-gold-400 sm:mt-6 sm:px-5 sm:py-2.5 sm:text-sm" data-id="element-328" data-mp="2y63raec0t05f">
        <PartyPopper className="h-4 w-4" aria-hidden="true" data-id="element-329" data-mp="3gyof3hcv4f2d" />
        Ahorras $127.01 — Un 93% de descuento
      </motion.p>
    </SectionShell>;
}